import { getAll } from '@/api/produit/produitDivers';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { SENS_VENTE } from '@/configuration/devisConf';

export function getLibelle(idProduitDivers, allProduitsDivers) {
  const produit = allProduitsDivers.find((produit) => {
    return produit.id === idProduitDivers;
  });
  return produit ? produit.libelle : null;
}

export async function getProduitDivers(sens) {
  const allProduitsLocation = (await getAll({
    orderBy: 'Libelle',
    ascending: true,
    query: { actif: null, sens: sens },
    maxResultCount: NO_PAGINATION,
  })).data.result.items;
  return allProduitsLocation;
}

export async function getLibelleProduitDiversDefaut(societe) {
  const allProduitsDivers = await getProduitDivers(SENS_VENTE);
  const produitLoc = {
    tlpe: getLibelle(societe.produitIdDefautTlpe, allProduitsDivers),
    honoraire: getLibelle(societe.produitIdHonoraire, allProduitsDivers),
    fraisTechnique: getLibelle(societe.produitIdDefautFraisTechnique, allProduitsDivers),
    pose: getLibelle(societe.produitIdDefautPose, allProduitsDivers),
    annulation: getLibelle(societe.produitIdAnnulationPaiement, allProduitsDivers),
  };
  return produitLoc;
}
